import React, { useState, Fragment } from 'react'
import styles from './TRouteCues.scss'
import { FullBleedList } from 'common/FullBleedList'
import { Icon } from 'common/Icon'
import { CueIcon } from 'common/CueIcon'
import { Distance } from 'common/units'
import { featureTypes } from 'common/MapV2/featureTypes.js'
import { Msg, useFormatMessage, commonMessages } from 'lib/localization'
import { FormattedMessage as T, defineMessages } from 'react-intl'

const cueMessages = defineMessages({
  cuesheet: {
    id: 'cueMessages.cuesheet',
    defaultMessage: 'Cuesheet'
  }
})

export class TRouteCues extends React.PureComponent {
  onCoursePointHovered = (index) => {
    const { onFeatureHovered, troute } = this.props
    if (index === null) {
      onFeatureHovered(null)
      return
    }
    onFeatureHovered({
      type: featureTypes.CUE,
      data: {
        index,
        coursePoint: troute.coursePoints[index]
      }
    })
  }

  onCoursePointClicked = (index) => {
    const { onFeatureSelected, troute } = this.props
    const coursePoint = troute.coursePoints[index]
    onFeatureSelected({
      type: featureTypes.CUE,
      firstI: coursePoint.i,
      data: {
        index,
        coursePoint
      }
    })
  }

  render () {
    const { troute } = this.props
    const editable = false

    return (
      <Fragment>
        {troute.coursePoints && troute.coursePoints.length > 0 && <div>
          <h2><Msg m={cueMessages.cuesheet} /></h2>
          <Cuesheet
            coursePoints={troute.coursePoints}
            onCoursePointHovered={this.onCoursePointHovered}
            onCoursePointClicked={this.onCoursePointClicked} />
        </div>}
        {troute.coursePoints && troute.coursePoints.length === 0 && <div className={styles.Cuesheet}>
          <h2><Msg m={cueMessages.cuesheet} /></h2>
          <p>
            {editable
              ? <T
                id='TRouteCues.noCuesEditable'
                defaultMessage='This route does not have a cuesheet. Visit our <a>help page</a> to learn how to add a cuesheet to this route.'
                values={{ a: (...c) => <a href='https://ridewithgps.com/help/trace-tool' target='_blank'>{c}</a> }} />
              : <T
                id='TRouteCues.noCuesNotEditable'
                defaultMessage='This route does not have a cuesheet. This route does not have a cuesheet. Look for the {icon} icon in listings to find routes with cuesheets.'
                values={{ icon: <Icon className={styles.light} i='md-document' data-tip title='Cuesheet' /> }} />}
          </p>
        </div>}
      </Fragment>
    )
  }
}

const Cuesheet = ({ coursePoints, onCoursePointHovered, onCoursePointClicked }) => {
  const [expanded, setExpanded] = useState(false)
  const points = expanded ? coursePoints : coursePoints.slice(0, 5)
  const fm = useFormatMessage()

  return (
    <div className={styles.Cuesheet}>
      <FullBleedList interactive expanded={expanded}>
        {points.map((cp, index) => (
          <li key={cp.i}
            onClick={() => onCoursePointClicked(index)}
            onMouseOver={() => onCoursePointHovered(index)}
            onMouseOut={() => onCoursePointHovered(null)}>
            <div className={styles.cueIcon}><CueIcon type={cp.t} className={styles.cueImg} /></div>
            <div className={styles.cueText}>{cp.n}</div>
            <div style={{ flex: '0 0 auto' }}><Distance value={cp.d} bigUnits maximumFractionDigits={1} minimumFractionDigits={1} short /></div>
          </li>
        ))}
      </FullBleedList>
      {coursePoints.length > 5 && <div className={styles.expandlink}>
        <a onClick={() => setExpanded(!expanded)}>{expanded
          ? <Msg m={commonMessages.collapse} values={{ list: fm(cueMessages.cuesheet) }} />
          : <T id='TRouteCues.showFull' defaultMessage='Show Full Cuesheet' />}
        </a>
      </div>}
    </div>
  )
}
